module.exports = __webpack_public_path__ + "img/arrow-down-solid.b6343c42.svg";